import { Controller } from "@hotwired/stimulus"

// Retour immédiat au clic sur une qualification.
//
// Qualifier une alerte part au serveur et revient en Turbo Stream qui remplace
// toute la carte Match(s). L'aller-retour se voit, et sans signal le clic
// paraissait sans effet : on éteint l'onglet et on fait tourner le bouton
// cliqué dès le départ de la requête.
//
// Rien à nettoyer en cas de succès — le panneau est remplacé, donc cet élément
// (et ses classes) disparaît avec lui ; `turbo:submit-end` couvre l'échec.
//
// Les faux positifs sont rangés au bout de la barre : quand l'onglet ouvert en
// est un (dossier clos, ou `?hit_id=`), il tombait hors de la piste visible.
// On l'y ramène à chaque rendu du panneau, horizontalement seulement :
// `scrollIntoView` faisait aussi défiler la page, sous le curseur.
export default class extends Controller {
  connect() {
    this.revealActiveTab()

    this.onSubmitStart = this.onSubmitStart.bind(this)
    this.onSubmitEnd = this.onSubmitEnd.bind(this)
    this.element.addEventListener("turbo:submit-start", this.onSubmitStart)
    this.element.addEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.onSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.onSubmitEnd)
    this.reset()
  }

  revealActiveTab() {
    const scroller = this.element.querySelector(".compliance-matches__tabs-scroller")
    const tab = scroller?.querySelector(".nav-link.active")
    if (!tab) return

    const track = scroller.getBoundingClientRect()
    const { left, right } = tab.getBoundingClientRect()
    if (right > track.right) scroller.scrollLeft += right - track.right
    else if (left < track.left) scroller.scrollLeft -= track.left - left
  }

  onSubmitStart(event) {
    const submitter = event.detail?.formSubmission?.submitter
    const form = event.target

    this.busyButton = submitter?.classList?.contains("btn") ? submitter : form.querySelector(".btn")
    this.busyPane = form.closest(".tab-pane")

    this.busyButton?.classList.add("compliance-qualify__btn--busy")
    this.busyPane?.classList.add("compliance-matches__pane--busy")
  }

  onSubmitEnd() {
    this.reset()
  }

  reset() {
    this.busyButton?.classList.remove("compliance-qualify__btn--busy")
    this.busyPane?.classList.remove("compliance-matches__pane--busy")
    this.busyButton = null
    this.busyPane = null
  }
}
